exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.discount-info>div[data-v-1e3606f0]{border-radius:1.6vw\n}\n.discount-info .repay-cash-back[data-v-1e3606f0]{margin-top:2.66667vw\n}\n.discount-info .repay-cash-back .cash-back-amount[data-v-1e3606f0]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;font-family:PingFangSC-Regular\n}\n.discount-info .repay-cash-back .cash-back-amount span[data-v-1e3606f0]:last-child{font-family:PingFangSC-Light;font-size:3.2vw;color:#999999\n}\n.discount-info .question-icon[data-v-1e3606f0]{width:3.2vw;height:2.93333vw;margin-left:4px;margin-top:-5px\n}\n", ""]);

// exports
